import sliceCreator from '../../index.js';
import {EDIT_ADMIN_REPORT} from '../../../constants/index.js';
const _editAdminDamageReportAction = sliceCreator('EDIT_ADMIN_REPORT',EDIT_ADMIN_REPORT, 'put');

const { asyncAction: editAdminDamageReportAction, reducer, clearData: clearEditAdminDamageReportAction } = _editAdminDamageReportAction;

export default reducer;

export {
    editAdminDamageReportAction,
    clearEditAdminDamageReportAction
}


